import type { InGameCompensationRewardsData } from "@/libs/SocketService";
import {
	createImmutableState,
	getImmutableStateProperty,
	setImmutableStateProperty,
} from "@/utils/state";
import { defineStore } from "pinia";
import type { ComputedRef } from "vue";

type RewardStoreState = {
	inGameRewards: InGameCompensationRewardsData["inGameRewards"] | null;
};

type RewardStore = {
	inGameCompensation: ComputedRef<
		InGameCompensationRewardsData["inGameRewards"] | null
	>;
	setInGameCompensation(
		rewards: InGameCompensationRewardsData["inGameRewards"],
	): void;
};

export default defineStore("reward", (): RewardStore => {
	const state = createImmutableState<RewardStoreState>({
		inGameRewards: null,
	});

	const inGameCompensation = getImmutableStateProperty(
		state,
		"inGameRewards",
		null,
	);

	const setInGameCompensation = (
		compensation: InGameCompensationRewardsData["inGameRewards"] | null,
	): void => {
		setImmutableStateProperty(
			state,
			"inGameRewards",
			compensation?.length ? compensation : null,
		);
	};

	return {
		inGameCompensation,
		setInGameCompensation,
	};
});
